import { Icon } from "react-frontier-v2"

interface Props{
   priority: number;
}

var PriorityLabel = (props: Props)=>{
   var { priority } = props;
   switch(priority){
      case 1:
         return <div style={{display: 'flex', gap: 5, alignItems: 'center', justifyContent: 'center'}}>
            <div style={{display: 'flex'}}>
               <Icon name="arrow-down" color="green" />
               <span style={{fontSize: 12, fontWeight: 700}}>Baja</span> 
            </div>
         </div>
      case 2:
         return <div style={{display: 'flex', gap: 5, alignItems: 'center', justifyContent: 'center'}}>
            <div style={{display: 'flex'}}>
               <Icon name="warning" color="orange" />
               <span style={{fontSize: 12, fontWeight: 700}}>Media</span> 
            </div>
         </div>
      case 3:
         return <div style={{display: 'flex', gap: 5, alignItems: 'center', justifyContent: 'center'}}>
            <div style={{display: 'flex'}}>
               <Icon name="arrow-up" color="orange" />
               <span style={{fontSize: 12, fontWeight: 700}}>Alta</span> 
            </div>
         </div>
      case 4:
         return <div style={{display: 'flex', gap: 5, alignItems: 'center', justifyContent: 'center'}}>
            <div style={{display: 'flex'}}>
               <Icon name="warning" color="red" />
               <span style={{fontSize: 12, fontWeight: 700}}>Crítica</span> 
            </div>
         </div>
      default:
         return null;
   }   
}

export default PriorityLabel